/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, mediaQuery } from '@insticator/insticator-ui'; // iui-utils



// ********* HELPERS ********* //
const pagePropertiesThinStyles = {
	width: pxToEm(150),
	'& .picker': {
		'& .sketch-picker': {
			width: `${pxToEm(130)} !important`,
		}
	}
};
const pagePropertiesThinnestStyles = {
	width: '100%',
	'& .picker': {
		'& .sketch-picker': {
			width: `${pxToEm(200)} !important`,
		}
	}
};



/* ++++++++++ --------------- EXPORT : EMBED PAGE PROPERTIES : STYLES --------------- ++++++++++ */
export default theme => ({
	cardproperties: {
		width: pxToEm(200)
	},
	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
	[mediaQuery.customizeThinnest]: {
		cardproperties: {
			extend: pagePropertiesThinnestStyles
		}
	},
	[mediaQuery.customizeRailThin]: {
		cardproperties: {
			'&.rail': {
				extend: pagePropertiesThinStyles
			}
		}
	},
	[mediaQuery.customizeInContentThin]: {
		cardproperties: {
			'&.incontent': {
				extend: pagePropertiesThinStyles
			}
		}
	}
});
